import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService } from '../../shared/service/api.service';


@Component({
  selector: 'app-cursos-tabela-submissao',
  templateUrl: './cursos-tabela-submissao.component.html',
  styleUrls: ['./cursos-tabela-submissao.component.scss', './../cursos.component.scss'],
})
export class CursosTabelaSubmissaoComponent implements OnInit {
  // componenteRef é usado para definir o id da barra de pesquisa, retornando uma
  // referencia de qual componente está chamando o componente "barra-busca"
  componenteRef = 'cursos';
  stringPesquisa: string;
  deslocamento = 0; // descolamento de página
  paginaAtual: number;
  totalPaginas: number;
  totalResultados: any;
  eixos: any;
  ordecao: any;
  filtro: any;
  eixo: any;
  // queryParamsSubscription: Subscription;
  realizouBusca = false;
  error = false;

  cursosTabelaSubmissao: any;

  constructor(private route: ActivatedRoute, private router: Router, private apiService: APIService) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const {
        cursosTabelaSubmissao: { itens, paginaAtual, totalPaginas, totalItens },
        cursoError,
        eixosError,
      } = data;

      this.error = cursoError !== undefined || eixosError !== undefined ? true : false;
      if (!this.error) {
        this.cursosTabelaSubmissao = itens;
        this.paginaAtual = paginaAtual;
        this.totalPaginas = totalPaginas;
        this.totalResultados = totalItens;
      }
    });
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/cursos/tabela-submissao'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }

  recebeuInput(input: string[]) {
    this.realizouBusca = true;
    [this.stringPesquisa, this.ordecao, this.eixo, this.filtro] = input;
    this.router.navigate(['/cursos/tabela-submissao'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: 1,
        eixo: this.eixo === 0 ? '' : this.eixo,
        filtro: this.filtro,
        ordenacao: this.ordecao,
        query: this.stringPesquisa,
      },
    });
  }

  downloadPdfCursosSubmissao() {
    this.apiService.getDownloadPdfCursosSubmissao().subscribe(
      (data: Blob) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'cursossubmissao.pdf';
        link.click();
      },
      error => {
        console.error('Erro ao baixar o PDF de cursos de submissão.', error);

      }
    );
  }

  downloadCsvCursosSubmissao() {
    this.apiService.getDownloadCsvCursosSubmissao()
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'cursossubmissao.csv'; // Substitua pelo nome desejado do arquivo
        link.click();

        // window.URL.revokeObjectURL(url);
      },
        error => {
          console.error('Erro ao baixar o CSV de cursos de submissão.', error);

        });
  }


}
